import { RaskRoller } from "./common/models/constants";
import { MenuItem } from "./common/services/menu/models/menu-models";

const MenuConfig = {
    name: "Huvudmeny",
    id: 1,
    truncation: false,
    hasSubmenu: true,
    truncationSubmenu: false,
    mainNodes: [
        {
            id: 100,
            name: "FORSALJNING_HEADER",
            url: "",
            aid: "forsaljning_meny",
            requiredRoles: RaskRoller.role.Titta,
            subMenuNodes: [
                {
                    aid: "forsaljning_produkt_meny",
                    name: "PRODUKT_HEADER",
                    url: "produkt"
                },
                {
                    aid: "forsaljning_handelssortiment_meny",
                    name: "HANDELSSORTIMENT_HEADER",
                    url: "handelssortiment"
                },
                {
                    aid: "forsaljning_kundorder_meny",
                    name: "KUNDORDER_HEADER",
                    url: "kundorder"
                },
                {
                    aid: "forsaljning_terminalorder_meny",
                    name: "TERMINALORDER_HEADER",
                    url: "terminalorder"
                },
                {
                    aid: "forsaljning_leverantorsorder_meny",
                    name: "LEVERANTORSORDER_HEADER",
                    url: "leverantorsorder"
                },
                {
                    aid: "forsaljning_mottagningsplats_meny",
                    name: "MOTTAGNINGSPLATS_HEADER",
                    url: "mottagningsplats"
                },
                {
                    aid: "forsaljning_kund_meny",
                    name: "KUND_HEADER",
                    url: "kund"
                },
                {
                    aid: "forsaljning_ckleverantor_meny",
                    name: "CKLEVERANTOR_HEADER",
                    url: "ckleverantor"
                }
            ]
        },
        {
            id: 200,
            name: "PRODUKTION_HEADER",
            url: "",
            aid: "produktion_meny",
            requiredRoles: RaskRoller.role.Titta,
            subMenuNodes: [
                {
                    aid: "produktion_produktionsmal_meny",
                    name: "PRODUKTIONSMAL_HEADER",
                    url: "produktionsmal"
                },
                {
                    aid: "produktion_planerangx_meny",
                    name: "PLANERA_HEADER",
                    url: "planera",
                    routerLinkActiveOptions: { exact: false }
                },
                {
                    aid: "produktion_minamaskinlag_meny",
                    name: "MINAMASKINLAG_HEADER",
                    url: "minamaskinlag"
                },
                {
                    aid: "produktion_minaproduktionsmallar_meny",
                    name: "MINAPRODUKTIONSMALLAR_HEADER",
                    url: "minaproduktionsmallar",
                    requiredRoles: RaskRoller.role.Produktionsleda
                },
                {
                    aid: "produktion_produktinstruktion_meny",
                    name: "PRODUKTINSTRUKTION_HEADER",
                    url: "produktinstruktioner"
                },
                {
                    aid: "produktion_sandningslogg_meny",
                    name: "SANDNINGSLOGG_HEADER",
                    url: "sandningslogg"
                }
            ]
        },
        {
            id: 300,
            name: "VIRKESKOP_HEADER",
            url: "/virkeskop",
            aid: "virkeskop_meny",
            requiredRoles: [
                RaskRoller.role.Kopleda,
                RaskRoller.role.Virkeskopa,
                RaskRoller.role.Kopplanera,
                RaskRoller.role.Prislisteadministrera,
                RaskRoller.role.Titta,
                RaskRoller.role.VirkeskopTitta
            ],
            subMenuNodes: [
                {
                    aid: "virkeskop_virkeskopanbudkontrakt_meny",
                    name: "VIRKESKOP_ANBUD_KONTRAKT_HEADER_SOK",
                    url: "virkeskop/avtal",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.VirkeskopTitta
                    ]
                },
                {
                    aid: "virkeskop_virkeskoptavtal_meny",
                    name: "VIRKESKOP_ANBUD_KONTRAKT_HEADER_SKAPA",
                    url: "virkeskop/avtal/ny",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                },
                {
                    aid: "virkeskop_virkeskopminahandelssortiment_meny",
                    name: "VIRKESKOP_ANBUD_KONTRAKT_HEADER_MINA_HANDELSSORTIMENT",
                    url: "virkeskop/minahandelssortiment",
                    requiredRoles: `${RaskRoller.role.Kopleda}, ${RaskRoller.role.Virkeskopa}`
                },
                {
                    aid: "virkeskop_virkesleverantor_meny",
                    name: "LEVERANTOR_HEADER",
                    url: "virkesleverantor",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                },
                {
                    aid: "virkeskop_marknadsprislista_meny",
                    name: "MARKNADSPRISLISTA_HEADER",
                    url: "virkeskop/marknadsprislista",
                    requiredRoles: [
                        RaskRoller.role.Prislisteadministrera,
                        RaskRoller.role.Titta
                    ]
                },
                {
                    aid: "virkeskop_minaforkalkylsmallar_meny",
                    name: "MINAFORKALKYLSMALLAR_HEADER",
                    url: "virkeskop/minaforkalkylsmallar",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                },
                {
                    aid: "virkeskop_externvirkeskop_meny",
                    name: "EXTERNVIRKESKOP_HEADER",
                    url: "externkontrakt",
                    state: "sokexternkontrakt",
                    showMenu: "sokImporteradeKontrakt",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                },
                {
                    aid: "virkeskop_karta_meny",
                    name: "KARTA_HEADER",
                    url: "virkeskop/virkeskopkarta",
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                }
            ]
        },
        {
            id: 325,
            name: "SKOGSVARDFPV_HEADER",
            url: "/skogsvardfpv",
            aid: "skogsvardfpv_meny",
            requiredRoles: [RaskRoller.role.Skogsvardsuppdragsplanera],
            subMenuNodes: [
                {
                    aid: "skogsvardfpv_sokanbudkontrakt_meny",
                    name: "SKOGSVARDFPV_HEADER_SOK",
                    url: "skogsvardfpv/avtal",
                    requiredRoles: [RaskRoller.role.Skogsvardsuppdragsplanera]
                },
                {
                    aid: "virkeskop_virkeskoptavtal_meny",
                    name: "SKOGSVARDFPV_ANBUD_KONTRAKT_HEADER_SKAPA",
                    url: "skogsvardfpv/avtal/ny",
                    requiredRoles: [RaskRoller.role.Skogsvardsuppdragsplanera]
                }
            ]
        },
        {
            id: 350,
            name: "TRANSPORT_HEADER",
            url: "",
            aid: "transport_meny",
            requiredRoles: RaskRoller.role.Titta,
            subMenuNodes: [
                {
                    aid: "transport_transportplanera_meny",
                    name: "TRANSPORTPLANERA_HEADER",
                    url: "transportplanera"
                },
                {
                    aid: "transport_destineringsomraden_meny",
                    name: "DESTINERINGSOMRADEN_HEADER",
                    url: "destineringsomraden"
                },
                {
                    aid: "transport_transportforetag_meny",
                    name: "TRANSPORTFORETAG_HEADER",
                    url: "transportforetag"
                }
            ]
        },
        {
            id: 400,
            name: "LEVERANS_HEADER",
            url: "",
            aid: "leverans_meny",
            requiredRoles: RaskRoller.role.Titta,
            subMenuNodes: [
                {
                    aid: "leverans_lagermal_meny",
                    name: "LAGERMAL_HEADER",
                    url: "lagermal"
                },
                {
                    aid: "leverans_justeraleveransplan_meny",
                    name: "Justera leveransplan",
                    url: "justeraleveransplan/kundorder"
                },
                {
                    aid: "sok_extern_arbetsorder_meny",
                    name: "SOKEXTERNARBETSORDER_HEADER",
                    url: "externarbetsorder"
                },
                {
                    aid: "produktionsmall_ck",
                    name: "CKPRODUKTIONSMALL_HEADER",
                    url: "ckproduktionsmall"
                }
            ]
        },
        {
            id: 500,
            name: "ADMINISTRATION_HEADER",
            url: "",
            aid: "administration_meny",
            requiredRoles: RaskRoller.role.Titta,
            subMenuNodes: [
                {
                    aid: "administration_mattslagskonvertering_meny",
                    name: "MATTSLAGSKONVERTERING_HEADER",
                    url: "mattslagskonvertering"
                },
                {
                    aid: "administration_sortiment_meny",
                    name: "SORTIMENT_HEADER",
                    url: "administration/sortiment"
                },
                {
                    aid: "administration_certifikat_meny",
                    name: "CERTIFIKAT_HEADER",
                    url: "administration/certifikat"
                },
                {
                    aid: "administration_kontraktsmigrering_meny",
                    name: "KONTRAKTSMIGRERING_HEADER",
                    url: "administration/kontraktsmigrering"
                },
                {
                    aid: "administration_produktionsomraden",
                    name: "PRODUKTIONSOMRADEN",
                    url: "administration/produktionsomrade"
                },
                {
                    aid: "administration_anvandare_meny",
                    name: "ANVANDARE_HEADER",
                    url: "administration/anvandare"
                },
                {
                    aid: "administration_systemadministration_meny",
                    name: "SYSTEMADMINISTRATION_HEADER",
                    url: "systemadministration"
                },
                {
                    aid: "administration_overvakning_meny",
                    name: "OVERVAKNING_HEADER",
                    url: "overvakning",
                    routerLinkActiveOptions: { exact: false },

                    requiredRoles: RaskRoller.role.Systemadministrera
                },
                {
                    aid: "administration_jobb_meny",
                    name: "JOBB_HEADER",
                    url: "jobb",
                    requiredRoles: RaskRoller.role.Systemadministrera
                },
                {
                    aid: "administration_rebus_meny",
                    name: "REBUS_HEADER",
                    url: "rebus",
                    requiredRoles: RaskRoller.role.Systemadministrera
                },
                {
                    aid: "administration_meddelandeInfotavla_meny",
                    name: "MEDDELANDEINFOTAVLA_HEADER",
                    url: "systemaktivitet"
                },
                {
                    aid: "administration_regelverkviol3_meny",
                    name: "REGELVERK_VIOL3",
                    url: "regelverkviol3"
                },
                {
                    aid: "administration_vikariehantering_meny",
                    name: "Vikariehantering",
                    url: "administration/vikariehantering"
                }
            ]
        }
    ]
} as MenuItem;

export default MenuConfig;
